'use strict';

var $ = require('dibs-jquery-shim');
var Backbone = require('dibs-backbone');
var isEmpty = require('lodash.isempty');
var SV = require('server-vars');
var template = require('../../../templates/pdp/modalCarousel').modalCarouselTemplate;
var SimpleModal = require('../../../components/SimpleModal/SimpleModal-view');
var CarouselBin = require('../../../components/CarouselBin/CarouselBin-view');
var ModalCarouselTracking = require('./ModalCarouselTracking');
var PinchZoom = require('../../../thirdParty/pinchzoom.modified');
var cssVars = require('../../../global/core/commonjs/cssVars');
var get = require('lodash.get');
var transitionHelpers = require('../../../global/utils/transitionHelpers');
var pinit = require('../../../social/pinit');
var ModalCarouselUIState = require('./ModalCarouselUIState');

var React = require('react');
var ReactDOM = require('react-dom');
var provideContext = require('fluxible-addons-react/provideContext');
var PinterestButton = require('../../../social/components/PinterestButton');
var pinterestActions = require('../../../global/actions/pinterestActions');
var pinterestUtils = require('../../../global/utils/social/pinterest');
var ArrowLeftIcon = require('dibs-vg/dist/templateString/arrow-left');
var ArrowRightIcon = require('dibs-vg/dist/templateString/arrow-right');

var ModalCarousel;
// React component reference needed for zoom modal on old PDP layout
// Todo: Remove once New PDP layout rolls out 100%


// Media query to determine if the user is on a tablet based on the screen dimensions.
function isTablet() {
    return window.matchMedia(
        '(min-width: ' + cssVars.breakpoints.pixel['mobile-large-landscape'] + ') and ' +
        '(max-width: ' + cssVars.breakpoints.pixel['tablet-landscape'] + ')'
    ).matches;
}

/**
 * @private
 * @deprecated - Remove once New PDP layout rolls out 100%
 * @param props
 */
function handlePinterestTracking(props) {
    pinit.track('share - zoom modal', props.url, props.description);
}

/**
 * Represents a full-page modal containing an image carousel. The carousel allows users to hover over the currently
 * selected image to zoom in and pan around.
 *
 * TODO: The non-modal functionality should be extracted out of this so it can also be used in the main PDP carousel.
 * A wrapper class containing the modal functionality should be used instead of this.
 */
ModalCarousel = Backbone.BaseView.extend({

    subViewConfig: {
        carouselBin: {
            construct: CarouselBin,
            location: '.modal-carousel-bin',
            singleton: true
        }
    },

    events: {
        'click .modal-carousel-previous': '_previous',
        'click .modal-carousel-next': '_next',
        'mouseenter .modal-carousel-small-image': '_zoomIn',
        'click .modal-carousel-purchase': '_purchase'
    },

    initialize: function (options) {
        options = options || {};

        if (!options.model) {
            throw new Error('ModalCarousel must have a model to be initialized.');
        }

        this.UIState = new ModalCarouselUIState();
        this._images = options.images || [];
        this._updateImageCallback = options.updateImageCallback;
        this._isTablet = isTablet();
        this._tracking = new ModalCarouselTracking({ imagesLength: this._images.length, item: this.model });

        // Used to render social buttons in React.
        this.context = options.context;
        this.socialData = !isEmpty(options.socialData) && options.socialData;
        this.siteProtocol = options.siteProtocol;

        // Add the modal as a property so we can interact with it directly.
        this.modal = new SimpleModal({
            content: this,
            manualHideCallback: function () {
                $(document).off('keydown', this._keyHandler);
            }.bind(this),
            classNames: {
                modal: 'is-full-page'
            }
        });

        this.subs.add({
            // Subview that handles the additional images that can be viewed in the footer.
            carouselBin: {

                // Just need the small version of the images here.
                images: this._images.map(function (image) {
                    return image.small;
                }),

                // We want to track whenever a user clicks directly on an image in the bin.
                jumpToImageCallback: this._tracking.thumbnailClick.bind(this._tracking),

                // We need to update the currently displayed image when a new image is selected, either from clicking
                // next/previous or directly on an image.
                updateImageCallback: function (index) {
                    this._jumpToImage();
                    this._transitionImage();
                    this._resetImageState();

                    if (typeof this._updateImageCallback === 'function') {
                        this._updateImageCallback(index);
                    }
                    this.UIState.setSelectedImage(this._getZoomImageSrc(this._getSelected()));
                }.bind(this)
            }
        });

        // Allow user to flip between images with the arrow keys. Need to bind this here so it can be removed and
        // re-added when the modal is closed/opened.
        this._keyHandler = function (e) {
            // Left arrow key
            if (e.which === 37) {
                this._previous();
            }

            // Right arrow key
            if (e.which === 39) {
                this._next();
            }
        }.bind(this);
    },

    render: function () {
        this.setElement(template({
            arrowLeftIcon: ArrowLeftIcon,
            arrowRightIcon: ArrowRightIcon,
            checkoutRoute: '/checkout/id-' + SV.get('data.pk') + '/',
            purchasable: 'boolean' === typeof this.model.canMakePurchase
                // head.js call comes back as a boolean
                ? this.model.canMakePurchase
                : this.model.canMakePurchase()
        }));

        this.$image = this.$('.modal-carousel-image');
        this.$smallImage = this.$('.modal-carousel-small-image');
        this.$body = this.$('.modal-carousel-body');

        if (this._isTablet) {
            // Using pinch-to-zoom library directly instead of using the wrapper. The wrapper added extra styling that
            // broke this case. Also need to turn off 2d transforms here because the library is causing a duplicate
            // image to flash on the screen when resizing if 2d is turned on.
            this._pinchZoom = new PinchZoom(this.$smallImage, {
                use2d: false
            });
            // Add a class to override some styling imposed by the library.
            this.$smallImage.parent().addClass('modal-carousel-pinch-zoom');
            this.$image.addClass('is-tablet');
        }

        if (this._images.length === 1) {
            this.$('.modal-carousel-previous').addClass('is-invisible');
            this.$('.modal-carousel-next').addClass('is-invisible');
        }

        this.UIState.setSelectedImage(this._getZoomImageSrc(this._getSelected()));
        if (this.socialData) {
            this._insertSocialIcons();
        }
        this._jumpToImage();
        this.subs.renderAppend();
        this.modal.render();

        return this;
    },

    /**
     * Show the view. Delegates to the underlying modal functionality. The consumer can pass in the start position
     * of the bin and the currently selected image. Otherwise it will retain its state from the previous opening.
     * @param  {number} imageIndex Index of the image that should be selected on open.
     * @param  {number} leftIndex  Index of the leftmost image in the bin that should be visible on open.
     */
    show: function (imageIndex, leftIndex) {
        this.subs.get('carouselBin').setPosition(imageIndex, leftIndex);
        $(document).on('keydown', this._keyHandler);
        this._tracking.showModal(imageIndex);
        this.modal.show();
    },

    /**
     * Get the currently selected image from the bin.
     * @return {number} The index of the currently selected image.
     */
    _getSelected: function () {
        return this.subs.get('carouselBin').getSelected();
    },

    /**
     * Helper method to grab the source of the zoom image.
     * @param  {number} index Index of the image to get.
     * @return {string}       The image source.
     */
    _getZoomImageSrc: function (index) {
        return get(this._images[index], 'zoom.src', '');
    },

    /**
     * Handle zooming into the image.
     */
    _zoomIn: function () {
        var mouseMoveHandler;

        // On tablet, zoom is handled by pinching via a library.
        if (this._isTablet) {
            return;
        }

        mouseMoveHandler = this._mouseMoveHandler.bind(this);

        // Update the background image of the zoom image.
        this.$image.css({
            backgroundImage: 'url(' + this._getZoomImageSrc(this._getSelected()) + ')'
        });

        this.$image.addClass('enlarged');

        // Setup handlers for panning around the image.
        this.$body.on('mousemove', mouseMoveHandler);
        this.$body.one('mouseleave', function () {
            this._zoomOut();
            this.$body.off('mousemove', mouseMoveHandler);
        }.bind(this));

        this._transitionImage();
    },

    /**
     * Handle zooming out of the image.
     */
    _zoomOut: function () {
        this._resetImageState();
        this._transitionImage();
    },

    /**
     * Updates the main image based on the image currently selected in the bin.
     */
    _jumpToImage: function () {
        var selected = this._getSelected();

        // Update the small image source.
        this.$smallImage.attr('src', this._getZoomImageSrc(selected));
    },

    /**
     * Handle image switch animation. This adds an initial class to prime the animation and then on the next tick
     * kicks off the animation. When the transition is complete, remove the classes.
     */
    _transitionImage: function () {
        transitionHelpers.transitionElement(this.$image);
    },

    /**
     * Move to the next image.
     */
    _next: function () {
        this.subs.get('carouselBin').next(this._tracking.nextClick.bind(this._tracking));
    },

    /**
     * Move the the next previous image.
     */
    _previous: function () {
        this.subs.get('carouselBin').previous(this._tracking.previousClick.bind(this._tracking));
    },

    /**
     * Reset the image to the "small" state.
     */
    _resetImageState: function () {
        if (this._isTablet) {
            this._pinchZoom.zoomOutAnimation();
        }

        this.$image.removeClass('enlarged');
        this.$image.css({
            backgroundImage: ''
        });
    },

    /**
     * Update the image position given the new coordinates.
     * @param  {number} translateX New X position for the image.
     * @param  {number} translateY New Y position for the image.
     */
    _translateImagePosition: function (translateX, translateY) {
        this.$image.css('backgroundPosition', 'calc(50% + ' + translateX + '%)' + translateY + '%');
    },

    /**
     * Handler for panning over the zoomed in image. Translate the mouse position into coordinates for the image.
     * @param  {object} e The mousemove event.
     */
    _mouseMoveHandler: function (e) {
        var mouseX = e.clientX;
        var mouseY = e.clientY;
        var bodyWidth = this.$body.width();
        var bodyHeight = this.$body.height();

        // Calculate offset from the center for the X axis.
        var translateX = ((mouseX / bodyWidth) - 0.5) * -50;
        var translateY = (mouseY / bodyHeight) * 100;

        this._translateImagePosition(translateX, translateY);
    },

    _purchase: function (e) {
        e.preventDefault();
        this._tracking.purchase();
        window.location = $(e.currentTarget).attr('href');
    },

    /**
     * HACK: Social icons are rendered server side and then an init script attaches event listeners to them. This
     * method grabs the existing icons from the page, clones them and re-attaches the required event handlers. A
     * better approach might be to create a component for the social icons and have the server generate the template
     * so the main PDP icons can be rendered server side but then more icons can be added later with the same HTML.
     */
    _insertSocialIcons: function () {
        var UIState = this.UIState;
        var $socialIcons = $('.social-share-nav .social-share-nav-item');
        var socialSelector = '.modal-carousel-social';
        var $socialIconsClone;
        var $pinterest;
        var props;
        var domContainer;

        // Detect if we are on the old PDP or the new one.
        if ($socialIcons.length) {
            $socialIconsClone = $socialIcons.clone();
            $pinterest = $socialIconsClone.filter('.pinterest').find('.social-share-nav-item-link');

            props = {
                url: $pinterest.data('url'),
                media: UIState.getSelectedImage(),
                description: $pinterest.data('title'),
                model: UIState,
                context: this.context
            };

            PinterestButton.prototype.pin = function () {
                var pinterestWindow = pinterestUtils.openWindow();
                this.context.executeAction(pinterestActions.pin, {
                    pinterestWindow: pinterestWindow,
                    url: this.props.url,
                    media: this.state.media,
                    description: this.props.description
                });
                handlePinterestTracking(this.props);
            };

            PinterestButton = React.createFactory(provideContext(PinterestButton));
            ReactDOM.render(PinterestButton(props), this.el.querySelector(socialSelector)); //eslint-disable-line
        } else if (!isEmpty(this.socialData)) {
            domContainer = this.$(socialSelector).html('<div class="pdp-social-icons is-modal" />').children()[0];

            PinterestButton = React.createFactory(provideContext(PinterestButton));
            ReactDOM.render(PinterestButton({ //eslint-disable-line
                url: this.socialData.url,
                media: UIState.getSelectedImage(),
                description: this.socialData.pinterest,
                model: UIState,
                context: this.context
            }), domContainer);
        }
    }

});

module.exports = ModalCarousel;



//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Carousel/ModalCarousel.js
// module id = 1574
// module chunks = 4 7